var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityCommentInput } from './entity-comment-input';
import { CommunityRequestThreads } from './community-request-threads';
import { PlusRoundedIconGlyph, TickIcon } from '@shapeable/icons';
import { useLang } from '../hooks/use-lang';
import { useEntityMutation } from '../hooks/use-entity-mutation';
import { useView } from '../hooks/use-view';
import { WaitMessage } from '../elements/wait-message';
import { useAppState } from '../hooks/use-app-state';
import { COMMUNITY_REQUEST_FIELDS, useCommunityRequestActions } from '../hooks/use-community-request-actions';
import { Dialog } from '../elements/dialog';
import { AppDialog } from '../app/app-dialog';
import { IconButton } from '../elements/icon-button';
import { Loader } from '../elements/loader';
import { useModal } from '../hooks/use-modal';
import { sprintf } from 'sprintf-js';
import { useCommunityRequestsPollingQuery } from '../hooks/use-community-requests-polling-query';
import { CommunityRequestTypeBanner } from './community-request-type-banner';
import pluralize from 'pluralize';
var cls = classNames('community-request-layout');
export var CommunityRequestLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BannerContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: center;\n    z-index: 10;\n  "], ["\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: center;\n    z-index: 10;\n  "])))
});
var BannerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    z-index: 10;\n    width: 100%;\n    padding: 0 ", " ", ";\n    background-color: ", ";\n  "], ["\n    z-index: 10;\n    width: 100%;\n    padding: 0 ", " ", ";\n    background-color: ", ";\n  "])), theme.UNIT(0), theme.UNIT(2), theme.COLOR('canvas')),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 0 ", " ", ";\n  "], ["\n    padding: 0 ", " ", ";\n  "])), theme.UNIT(0), theme.UNIT(3))
});
var CreateRequestButtonStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    top: 82px;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    padding: ", " 0;\n    background-color: ", ";\n    border-radius: 0 0 ", " ", ";\n    border-left: 2px solid ", ";\n    border-right: 2px solid ", ";\n    border-bottom: 2px solid ", ";\n    width: 80%;\n    opacity: 0.95;\n\n    &:hover {\n      opacity: 1;\n      transition: opacity 0.3s;\n    }\n  "], ["\n    position: absolute;\n    top: 82px;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    padding: ", " 0;\n    background-color: ", ";\n    border-radius: 0 0 ", " ", ";\n    border-left: 2px solid ", ";\n    border-right: 2px solid ", ";\n    border-bottom: 2px solid ", ";\n    width: 80%;\n    opacity: 0.95;\n\n    &:hover {\n      opacity: 1;\n      transition: opacity 0.3s;\n    }\n  "])), theme.UNIT(6), theme.COLOR('app-chrome'), theme.UNIT(3), theme.UNIT(3), theme.COLOR('line-very-subtle'), theme.COLOR('line-very-subtle'), theme.COLOR('line-very-subtle')),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    top: 56px;\n  "], ["\n    top: 56px;\n  "])))
});
var RequestLabelStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme.UNIT(2))
});
var RequestInputStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    gap: ", ";\n    padding-top: 0;\n    margin-top: 0;\n    width: 100%;\n    top: 70px;\n    left: 0;\n    opacity: 0;\n    visibility: hidden;\n    max-height: 0;\n    overflow: hidden;\n    transition: \n      opacity 0.3s ease, \n      visibility 0s linear 0.3s, \n      max-height 0.6s ease-in-out,\n      padding-top 0.8s ease-in-out, \n      margin-top 0.8s ease-in-out;\n\n    .shp--entity-comment-input__body {\n      width: 100%;\n      box-sizing: border-box;\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    gap: ", ";\n    padding-top: 0;\n    margin-top: 0;\n    width: 100%;\n    top: 70px;\n    left: 0;\n    opacity: 0;\n    visibility: hidden;\n    max-height: 0;\n    overflow: hidden;\n    transition: \n      opacity 0.3s ease, \n      visibility 0s linear 0.3s, \n      max-height 0.6s ease-in-out,\n      padding-top 0.8s ease-in-out, \n      margin-top 0.8s ease-in-out;\n\n    .shp--entity-comment-input__body {\n      width: 100%;\n      box-sizing: border-box;\n    }\n\n    ", "\n  "])), theme.UNIT(2), function (_a) {
    var isVisible = _a.isVisible;
    return isVisible && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    opacity: 1;\n      width: 100%;\n      top: 70px;\n      left: 0;\n      max-height: calc(100vh - 70px);\n      padding-top: ", ";\n      margin-top: ", ";\n      visibility: visible;\n      overflow: auto;\n      transition: \n        opacity 0.3s ease, \n        max-height 0.8s ease-in-out, \n        padding-top 0.8s ease-in-out, \n        margin-top 0.8s ease-in-out;\n      \n    "], ["\n    opacity: 1;\n      width: 100%;\n      top: 70px;\n      left: 0;\n      max-height: calc(100vh - 70px);\n      padding-top: ", ";\n      margin-top: ", ";\n      visibility: visible;\n      overflow: auto;\n      transition: \n        opacity 0.3s ease, \n        max-height 0.8s ease-in-out, \n        padding-top 0.8s ease-in-out, \n        margin-top 0.8s ease-in-out;\n      \n    "])), theme.UNIT(1), theme.UNIT(2));
  }),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n  "], ["\n  ", "\n  "])), function (_a) {
    var isVisible = _a.isVisible;
    return isVisible && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    top: 48px;\n  "], ["\n    top: 48px;\n  "])));
  })
});
var CoversationsStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n   height: 70vh;\n  "], ["\n   height: 70vh;\n  "])))
});
var DeleteDialogBodyStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", " 0;\n    text-align: center;\n    overflow-y: auto;\n    max-height: calc(90vh - 55px - 60px);\n    box-sizing: border-box;\n        \n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", " 0;\n    text-align: center;\n    overflow-y: auto;\n    max-height: calc(90vh - 55px - 60px);\n    box-sizing: border-box;\n        \n  "])), theme.UNIT(2))
});
var DeleteDialogStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var WaitMessageStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    height: 400px;\n    width: 100%;\n    align-self: center;\n  "], ["\n    height: 400px;\n    width: 100%;\n    align-self: center;\n  "])))
});
var DeleteConfirmButtonStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    align-self: center;\n  "], ["\n    align-self: center;\n  "])))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'CommunityRequestLayout',
  Container: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  BannerContainer: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), BannerContainerStyles),
  Banner: styled(CommunityRequestTypeBanner)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  CreateRequestButton: styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), CreateRequestButtonStyles),
  RequestLabel: styled.span(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), RequestLabelStyles),
  // DeleteDialog: styled(EntityDeleteDialog)`${DeleteDialogStyles}`,
  DeleteDialog: styled(Dialog)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), DeleteDialogStyles),
  DelteDialogBody: styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), DeleteDialogBodyStyles),
  DeleteAppDialog: styled(AppDialog)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), DeleteDialogStyles),
  DeleteConfirmButton: styled(IconButton)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), DeleteConfirmButtonStyles),
  Loader: styled(Loader)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  RequestInput: styled(EntityCommentInput)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), RequestInputStyles),
  ConversationThreads: styled(CommunityRequestThreads)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), CoversationsStyles),
  WaitMessage: styled(WaitMessage)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageStyles)
};
export var CommunityRequestLayout = function (props) {
  var _a, _b;
  var _c = useComponentProps(My.NAME, CommunityRequestLayoutDefaultProps, props),
    className = _c.className,
    children = _c.children,
    _d = _c.items,
    items = _d === void 0 ? [] : _d,
    activeEntity = _c.activeEntity;
  var ALL_ITEMS_KEY = 'all-items';
  var _e = __read(useAppState(), 2),
    appState = _e[0],
    setAppState = _e[1];
  var modal = useModal();
  var _f = useView('conversations', '', ALL_ITEMS_KEY),
    activeSubView = _f.activeSubView,
    filters = _f.filters;
  var entityTypeName = 'CommunityRequest';
  var pluralisedName = !!activeEntity && pluralize(activeEntity.name);
  var t = useLang();
  var _g = useCommunityRequestsPollingQuery(),
    allCommunityRequests = _g.data,
    apolloLoading = _g.apolloLoading,
    showPageLoader = _g.showPageLoader,
    refetchRequests = _g.refetch;
  var _h = useCommunityRequestActions({
      refetchRequests: refetchRequests,
      onSuccessSubmit: function (isEdit) {
        setShowInputModal(false);
        setEditingRequest(null);
        setSelectedDropdownItem(null);
      }
    }),
    handleSubmitRequest = _h.handleSubmitRequest,
    setIsDeleting = _h.setIsDeleting,
    setShowInputModal = _h.setShowInputModal,
    setEditingRequest = _h.setEditingRequest,
    setSelectedDropdownItem = _h.setSelectedDropdownItem,
    selectedDropdownItem = _h.selectedDropdownItem,
    editingRequest = _h.editingRequest,
    showInputModal = _h.showInputModal,
    isSubmitting = _h.isSubmitting,
    isDeleting = _h.isDeleting;
  // Handles ViewState for activeView (selected Item or all) and the filtered items by isCompleted
  var filteredRequests = useMemo(function () {
    var _a;
    var requestsToFilter = allCommunityRequests || [];
    if (activeSubView && activeSubView !== ALL_ITEMS_KEY) {
      requestsToFilter = requestsToFilter.filter(function (request) {
        var _a;
        return ((_a = request.type) === null || _a === void 0 ? void 0 : _a.id) === activeSubView;
      });
    }
    var showOnlyUnCompleted = (_a = appState === null || appState === void 0 ? void 0 : appState.isCompleted) !== null && _a !== void 0 ? _a : false;
    if (showOnlyUnCompleted) {
      requestsToFilter = requestsToFilter.filter(function (request) {
        return !request.isCompleted === true;
      });
    }
    return requestsToFilter;
  }, [activeSubView, allCommunityRequests, filters, appState === null || appState === void 0 ? void 0 : appState.isCompleted]);
  // need to create a boolean condition to determine when the 
  var isEmpty = !showPageLoader && !filteredRequests.length;
  var deleteMutation = useEntityMutation({
    entityTypeName: entityTypeName,
    type: 'Delete',
    fields: COMMUNITY_REQUEST_FIELDS
  });
  var onDelete = function (entity) {
    return __awaiter(void 0, void 0, void 0, function () {
      var error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setIsDeleting(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            modal.show(React.createElement(My.DeleteDialog, {
              title: sprintf(t('Delete %s')),
              isCancelButtonDisabled: true,
              maxWidth: '500px'
            }, React.createElement(My.Loader, {
              spinnerSize: 18
            })));
            return [4 /*yield*/, deleteMutation.submit({
              variables: {
                id: entity.id
              }
            }).catch(function (error) {
              console.error('Mutation error:', error);
            })];
          case 2:
            _a.sent();
            refetchRequests();
            modal.hide();
            return [3 /*break*/, 5];
          case 3:
            error_1 = _a.sent();
            console.error("Failed to delete comment:", error_1);
            modal.hide();
            return [3 /*break*/, 5];
          case 4:
            setIsDeleting(false);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  var confirmDelete = function (entity) {
    var label = 'Bulletin';
    modal.show(React.createElement(My.DeleteAppDialog, {
      action: 'delete',
      onCloseClick: function () {
        return modal.hide();
      },
      onButtonAction: function () {
        return onDelete(entity);
      },
      startControls: !isDeleting && React.createElement(My.DeleteConfirmButton, {
        iconSize: 20,
        icon: React.createElement(TickIcon, null),
        onClick: function () {
          return onDelete(entity);
        }
      }, t('Confirm')),
      title: sprintf(t('%s'), label)
    }, React.createElement(My.DelteDialogBody, null, sprintf(t('Are you sure you want to delete this %s?'), label), React.createElement("br", null), React.createElement("br", null), React.createElement("b", null, t('This is not reversible.')))));
  };
  var handleEditRequest = function (requestToEdit) {
    setShowInputModal(true);
    setEditingRequest(requestToEdit);
    setSelectedDropdownItem(requestToEdit.type);
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(React.Fragment, null, React.createElement(My.BannerContainer, null, React.createElement(My.Banner, {
    allItemsTitle: pluralisedName || 'All Bulletins'
  }), React.createElement(My.CreateRequestButton, {
    onClick: function () {
      setEditingRequest(null);
      setShowInputModal(!showInputModal);
    }
  }, React.createElement(My.RequestLabel, null, t('Submit a Request')), React.createElement(PlusRoundedIconGlyph, {
    size: 18,
    colors: {
      fill: 'strong'
    }
  })), React.createElement(My.RequestInput, {
    key: "thread-input-".concat(editingRequest ? editingRequest.id : 'new'),
    isVisible: showInputModal,
    isMainInput: true,
    inputVariant: 'thread',
    selectsLabel: 'Bulletin Type:',
    dropdownEntityType: 'CommunityRequestType',
    setSelectedDropdownItem: setSelectedDropdownItem,
    selectedDropdownItem: selectedDropdownItem,
    isSubmitting: isSubmitting,
    onCancel: function () {
      setShowInputModal(false);
      setSelectedDropdownItem(null);
    },
    initialValues: editingRequest ? {
      title: editingRequest.title,
      description: ((_a = editingRequest.description) === null || _a === void 0 ? void 0 : _a.text) || '',
      typeId: (_b = editingRequest.type) === null || _b === void 0 ? void 0 : _b.id
    } : undefined,
    onSubmit: handleSubmitRequest({
      id: editingRequest === null || editingRequest === void 0 ? void 0 : editingRequest.id
    })
  })), showPageLoader ? React.createElement(My.WaitMessage, {
    loading: true
  }, t('Loading. Please wait...')) : React.createElement(My.ConversationThreads, {
    items: filteredRequests,
    loading: showPageLoader,
    onEditRequest: handleEditRequest,
    onDeleteRequest: confirmDelete
  })), children);
};
CommunityRequestLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30;